import { render, staticRenderFns } from "./allGradesComparison_new.vue?vue&type=template&id=a0cb733c&scoped=true&"
import script from "./allGradesComparison_new.vue?vue&type=script&lang=js&"
export * from "./allGradesComparison_new.vue?vue&type=script&lang=js&"
import style0 from "./allGradesComparison_new.vue?vue&type=style&index=0&id=a0cb733c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cb733c",
  null
  
)

export default component.exports